import { adjustTo25IfTodayIsAfter25 } from 'src/utils/contracts';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';

const makeInitialState = values => {
  return {
    id: values.id ?? '',
    clientId: values.clientId ?? '',
    term: values && values.term,
    moreInfo: values.moreInfo ?? '',
    price: values.price ?? '',
    initialPaymentAmount: values.price * (values.initialPayment / 100) ?? '',
    initialPaymentDate: values.initialPaymentDate
      ? momentLocalTimezone(values.initialPaymentDate)
      : momentLocalTimezone(),
    firstRentDate:
      adjustTo25IfTodayIsAfter25(momentLocalTimezone(values.firstRentDate)) ??
      adjustTo25IfTodayIsAfter25(momentLocalTimezone()),
    iva: values.iva ?? '',
    gracePeriod: values.gracePeriod ?? '',
    phone: values.client ? values.client.phone : values.clientData?.phone ?? '',
    isMsiModality: values.isMsiModality ?? false,
    isFirstUpfrontRentModality: values.isFirstUpfrontRentModality ?? false,
    selectedTerms: values.selectedTerms ?? []
  };
};

export default makeInitialState;
